import { useCallback } from "react";
import { NAV_ITEMS } from "@/lib/nav";
import { canSeeNav } from "@/components/layout/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { useT52 } from "@/i18n/v52";

export const Dash = ({ v }) => (v === null || v === undefined || v === "" ? <span className="f52-dash">—</span> : <>{v}</>);

export const PlanChip = ({ plan }) => (plan ? <span className={`f52-plan ${plan}`}>{plan}</span> : <Dash v={null} />);

export const QaTag = () => <span className="f52-qa-tag">QA</span>;

export function useCanSee() {
  const { user } = useAuth();
  return useCallback((key) => {
    const it = NAV_ITEMS.find((i) => i.key === key);
    return !!it && canSeeNav(user, it);
  }, [user]);
}

export function useFmt() {
  const { locale } = useT52();
  return useCallback((iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d.toLocaleString(locale, { dateStyle: "short", timeStyle: "short" });
  }, [locale]);
}

export function Empty52({ icon: Icon, title, text, tone = "", testid, role, children }) {
  return (
    <div className={`f52-empty ${tone}`} data-testid={testid} role={role}>
      <span className="ico"><Icon aria-hidden="true" /></span>
      <h3>{title}</h3>
      {text && <p>{text}</p>}
      {children}
    </div>
  );
}
